import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Typo } from "../../../../typography";
const sizeMap = (gap) => ({
    small: {
        s: "1 100%",
        l: "1 100%",
    },
    medium: {
        s: `0 calc(50% - ${gap})`,
        l: `0 calc(50% - ${gap})`,
    },
    large: {
        s: `0 calc(33.33% - ${gap})`,
        l: `0 calc(50% - ${gap})`,
    },
    xlarge: {
        s: `0 calc(33.33% - ${gap})`,
        l: `0 calc(50% - ${gap})`,
    },
});
export const StyledWrapper = styled.div `
  ${({ theme, widthBorder }) => widthBorder ? `border: 1px solid ${theme.colors.grey09}` : ""};
  border-top: none;
  padding: 1.5rem 1.5rem 1rem 1.5rem;

  &&& a {
    align-items: center;
    padding: 0.5rem;
  }
  &&& a span:first-of-type {
    position: unset;
    position: unset;
  }
  &&&& a span:last-of-type {
    border-top: 1px solid transparent;
  }
`;
export const HeadlineWithShortTeaserContainer = styled.div `
  &&& {
    background-color: ${({ theme, customBackgroundColor }) => customBackgroundColor && customBackgroundColor === "light"
    ? `rgba(${theme.colors.transparentBlack}, 0.06)`
    : theme.colors.white};
    ${({ size = "s", gap }) => `flex: ${sizeMap(gap).small[size]};`}

    display: flex;
    flex-direction: column;
    transition: all 0.5s ease-in-out;

    .border-layer {
      border: 1px solid rgba(0, 0, 0, 0.2);
    }

    &:hover {
      ${({ theme }) => `background: ${theme.colors.cl05};`}
    }

    &:focus {
      .border-layer {
        ${({ theme, focused }) => focused && `border: 2px solid ${theme.colors.cl17};`}
      }
    }

    &:active:is(:focus) {
      .border-layer {
        ${({ theme }) => `border: 1px solid ${theme.colors.black};`};
      }
    }

    & ${StyledWrapper} {
      flex: 1;
    }

    position: relative;
    min-height: 13.5rem;
    box-sizing: border-box;
    outline: none;

    @media ${({ theme }) => theme.device.medium} {
      ${({ size = "s", gap }) => `flex: ${sizeMap(gap).medium[size]};`}
    }

    @media ${({ theme }) => theme.device.large} {
      ${({ size = "s", gap }) => `flex: ${sizeMap(gap).large[size]};`}
    }
  }
`;
export const StyledParagraph = styled((props) => (_jsx(Typo, Object.assign({}, props)))) `
  &&& {
    margin: 0.75rem 0 0.5rem 0;
    color: ${({ theme }) => theme.colors.grey14};
  }
`;
export const StyledLinkWrapper = styled.div `
  &&& {
    display: flex;
    justify-content: flex-end;
  }
`;
export const StyledTypo = styled((props) => (_jsx(Typo, Object.assign({}, props)))) `
  &&& {
    margin: 0;
    font-weight: ${({ theme }) => theme.fontWeights.regular};
    color: ${({ theme }) => theme.colors.grey09};
  }
`;
export const StyledTitle = styled((props) => (_jsx(Typo, Object.assign({}, props)))) `
  &&& {
    margin: 0;
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }
`;
